export const apiDomain = "https://cheat-sheet-maker-server.vercel.app";
